import { INITIALIZE_APP } from '../actions/initialize';
import { SET_USER_HAS_LOGGED_OUT } from '../actions/auth';
import { UserActionType } from '../actions/user';
import {
    RETRIEVE_ORDER_FAILURE,
    SET_USER_HAS_PASSWORD,
    SET_ORGANIZER_MARKETING_OPT_IN,
} from '../actions/order/constants';

import { REMOVE_APP_ERROR } from '../actions/errors';
import { SET_RELOAD_AFTER_CHECKOUT } from '../actions/constants';
import { UPDATE_PAYIN_AMOUNT_LOCK_STATUS } from '../actions/payIn/payIn';

export const appReducer = (state = {}, action) => {
    switch (action.type) {
        case INITIALIZE_APP:
            return {
                ...state,
                ...action.payload,
            };

        // TODO: EB-143943 - Move to user reducer
        case SET_USER_HAS_LOGGED_OUT: {
            return {
                ...state,
                user: {
                    hasLoggedOut: action.payload,
                },
            };
        }

        // TODO: EB-143943 - Move to user reducer
        case UserActionType.setUserAsLoggedIn:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };

        // TODO: EB-143919 - Move to user reducer
        case SET_USER_HAS_PASSWORD: {
            return {
                ...state,
                user: {
                    ...state.user,
                    hasPassword: action.payload,
                },
            };
        }

        case SET_RELOAD_AFTER_CHECKOUT: {
            return {
                ...state,
                reloadAfterCheckout: action.payload,
            };
        }

        case SET_ORGANIZER_MARKETING_OPT_IN: {
            return {
                ...state,
                enableOrganizerMarketingOptIn: action.payload,
            };
        }

        case RETRIEVE_ORDER_FAILURE: {
            return {
                ...state,
                errors: [...state.errors, action.payload],
            };
        }

        case REMOVE_APP_ERROR: {
            return {
                ...state,
                errors: state.errors.filter(
                    (error) => error.error !== action.payload,
                ),
            };
        }

        case UPDATE_PAYIN_AMOUNT_LOCK_STATUS:
            return {
                ...state,
                payins: {
                    ...(state.payins || {}),
                    amountLocked: action.payload,
                },
            };

        default:
            return state;
    }
};

const getWidgetParentUrl = (state) => state.widgetParentUrl;

export const selectors = {
    getWidgetParentUrl,
};
